module.exports = __webpack_public_path__ + "img/CYTS.a800daa9.png";